var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import MUIAdvantagesList from '../../../../uikit/special/AdvantagesList';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { ScrollingUtils } from '../../../../utils/scrolling.utils';
import { Col, Container, Row } from '../../../../uikit/grid';
import useEmotionStyles from '../../../../uikit/hooks/useEmotionStyles';
import { APPLICANT_PAGE__POINT_TO_SCROLL_ID, MAIN_FORM_PAGE__LAYOUT_GRID, } from '../../config';
var t = getTranslation(translations);
var advantages = [t.point1, t.point2, t.point3, t.point4, t.point5];
var SCROLL_OFFSET = 30;
var styles = function () { return ({
    root: {
        background: 'rgba(34, 34, 34, 0.9)',
        padding: '40px 0 60px',
    },
}); };
export default function AdvantagesList() {
    var cs = useEmotionStyles(styles);
    var handleButtonClick = useCallback(function () {
        if (typeof window === 'undefined') {
            return;
        }
        var element = document.getElementById(APPLICANT_PAGE__POINT_TO_SCROLL_ID);
        if (element === null) {
            return;
        }
        var scrollTo = ScrollingUtils.getYPosOnPage(element) - SCROLL_OFFSET;
        ScrollingUtils.smoothScrollTo(scrollTo);
    }, []);
    return (React.createElement("div", { className: cs.root },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, __assign({}, MAIN_FORM_PAGE__LAYOUT_GRID),
                    React.createElement(MUIAdvantagesList, { title: t.title, advantages: advantages, btnTitle: t.buttonTitle, onClick: handleButtonClick, inserted: false }))))));
}
